export const NAME_SPACE = ["en", "ar"]

// Base paths that are common across all tenants
export const DEFAULT_PATHS = {
  HOME_PATH: "/",
  ABOUT_US_PATH: "/about-us",
  CONTACT_US_PATH: "/contact-us",
  TERMS_PATH: "/terms",
  PRIVACY_POLICY_PATH: "/privacy-policy",
  LOGIN_PATH: "/login",
  PROJECTS_PATH: "/projects",
  DASHBOARD_PATH: "/dashboard",
  PROFILE_PATH: "/profile",
  CLIENTS_PATH: "/clients",
  INVENTORY_PATH: "/inventory",
  LEADS_PATH: "/leads",
  RESET_PASSWORD_PATH: "/reset-password",
  FAQ_PATH: "/faqs",
}

// Export individual paths with default values
export const HOME_PATH = DEFAULT_PATHS.HOME_PATH
export const ABOUT_US_PATH = DEFAULT_PATHS.ABOUT_US_PATH
export const CONTACT_US_PATH = DEFAULT_PATHS.CONTACT_US_PATH
export const TERMS_PATH = DEFAULT_PATHS.TERMS_PATH
export const PRIVACY_POLICY_PATH = DEFAULT_PATHS.PRIVACY_POLICY_PATH
export const LOGIN_PATH = DEFAULT_PATHS.LOGIN_PATH
export const PROJECTS_PATH = DEFAULT_PATHS.PROJECTS_PATH
export const DASHBOARD_PATH = DEFAULT_PATHS.DASHBOARD_PATH
export const PROFILE_PATH = DEFAULT_PATHS.PROFILE_PATH
export const CLIENTS_PATH = DEFAULT_PATHS.CLIENTS_PATH
export const INVENTORY_PATH = DEFAULT_PATHS.INVENTORY_PATH
export const LEADS_PATH = DEFAULT_PATHS.LEADS_PATH
export const RESET_PASSWORD_PATH = DEFAULT_PATHS.RESET_PASSWORD_PATH
export const FAQ_PATH = DEFAULT_PATHS.FAQ_PATH
